import Collapse from '@material-ui/core/Collapse'
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles'
import MuiAlert, { AlertProps as Props } from '@material-ui/lab/Alert'
import * as React from 'react'

export type AlertType = 'primary' | 'secondary' | 'error' | 'success'

export type AlertLuceProps = {
  type?: AlertType
  isOpen?: boolean
  onClose?(): void
} & Props

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      ...theme.typography.body2,
      width: '100%',
      color: theme.palette.common.white,
      '& .MuiAlert-icon': {
        display: 'none'
      }
    },
    primary: {
      background: theme.palette.common.black
    },
    secondary: {
      background: theme.palette.grey[400],
      color: theme.palette.common.black
    },
    error: {
      background: theme.palette.error.main
    },
    success: {
      background: theme.palette.success.main
    }
  })
)

export const Alert: React.FC<AlertLuceProps> = (props) => {
  const { children, type, isOpen, onClose = () => {}, ...rest } = props
  const classes = useStyles()
  const getType = (typeAlert: string) => {
    if (typeAlert === undefined) {
      return { root: classes.primary }
    } else if (type === typeAlert) {
      return { root: classes[typeAlert] }
    }
  }
  return (
    <Collapse in={isOpen}>
      <MuiAlert
        className={classes.root}
        classes={getType(type as string)}
        onClose={() => onClose()}
        {...rest}
      >
        {children}
      </MuiAlert>
    </Collapse>
  )
}
